import { useEffect, useState, useCallback } from "react";

// Theme preference — non-sensitive UX state. localStorage is appropriate.
const KEY = "s2s_theme";

function applyTheme(t) {
  const root = document.documentElement;
  if (t === "dark") root.classList.add("dark");
  else root.classList.remove("dark");
}

export function useTheme() {
  const [theme, setTheme] = useState(() => {
    if (typeof window === "undefined") return "light";
    try {
      return localStorage.getItem(KEY) || "light";
    } catch (e) {
      console.warn("theme read failed", e);
      return "light";
    }
  });

  useEffect(() => { applyTheme(theme); }, [theme]);

  const toggle = useCallback(() => {
    setTheme((t) => {
      const next = t === "dark" ? "light" : "dark";
      try {
        localStorage.setItem(KEY, next);
      } catch (e) {
        console.warn("theme write failed", e);
      }
      return next;
    });
  }, []);

  return { theme, toggle };
}
